import { RelatoriosList } from "@/components/relatorios/RelatoriosList";

export default function RelatoriosPage() {
  return (
    <div className="space-y-6">
      <RelatoriosList />
    </div>
  );
}
